import * as React from 'react';
import { Component, RefObject } from 'react';
import { ButtonCallToAction, ButtonTertiary, MeatballMenu, PromptConfirmationModal } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { CodetableTranslation } from '../../constants';
import styles from './codetable-sticky-header.scss';
import { DisabledTag } from 'app/area/codetable/common/disabled-tag/disabled-tag';
import { CodeActionType, ReadOnlyConfiguration, ReadOnlyType } from 'app/area/codetable/item/types';
import { CodeItem } from 'app/area/codetable/item/types-store';

export interface CodetableStickyHeaderProps {
  codetableId: number;
  codeItem: CodeItem;
  breadcrumbs: number[];
  codeId: number;
  name: string;
  codetableName: string;
  actionType: CodeActionType;
  translation: CodetableTranslation;
  longDescription?: string;
  disabled: Date;
  readOnlyConfig: ReadOnlyConfiguration;
  save: () => void;
  cancel: () => void;
  deleteCodeItem: () => void;
  duplicateCodeItem: () => void;
}

export class CodetableStickyHeader extends Component<CodetableStickyHeaderProps> {

  private longDescriptionRef: RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

  public render() {
    const {
      codetableId, name, codetableName, longDescription, actionType, codeId, translation,
      save, cancel, deleteCodeItem, duplicateCodeItem, codeItem, readOnlyConfig
    } = this.props;

    const buttonText = {
      [CodeActionType.Add]: translation.add_code,
      [CodeActionType.Edit]: translation.update_code,
      [CodeActionType.Duplicate]: translation.duplicate_code
    }[actionType];

    return (
      <StickyHeader className={styles.stickyHeader} rightSideContent={<>
        <StickyHeaderButtonContainer>
          <ButtonTertiary id={`codetable-sticky-header-cancel-button-${codetableId}`} onClick={cancel}>
            {translation.cancel}
          </ButtonTertiary>
          {!readOnlyConfig[ReadOnlyType.save] && <ButtonCallToAction
            id={`codetable-sticky-header-save-button-${codetableId}`}
            onClick={save}>
            {buttonText}
          </ButtonCallToAction>}
        </StickyHeaderButtonContainer>
        {!!codeId && codeId > 0 && actionType !== CodeActionType.Duplicate && (duplicateCodeItem || deleteCodeItem)
          && <MeatballMenu id="codetable-sticky-header-meatballmenu">
            {duplicateCodeItem && <li>
              <button type="button" className="dropdown-item" onClick={duplicateCodeItem}>
                {!!translation && translation.duplicate_code}
              </button>
            </li>}
            {deleteCodeItem && <li>
              <PromptConfirmationModal
                title={translation.delete_code_item}
                description={translation.delete_confirm}
                continueText={translation.delete_code_item}
                cancelText={translation.cancel}
                onContinue={deleteCodeItem} >
                <button type="button" className="dropdown-item">
                  {!!translation && translation.delete}
                </button>
              </PromptConfirmationModal>
            </li>}
          </MeatballMenu>}
      </>}>
        <div className={styles.title}>{codetableName}</div>
        <div className={styles.actionTitleContainer}>
          {actionType === CodeActionType.Edit && <span className={styles.id}>#{codeId}</span>}
          <h2 className={styles.actionTitle}>
            {actionType === CodeActionType.Edit
              ? name
              : (actionType === CodeActionType.Add ? translation.new_code_item : translation.duplicate_code_item)}
          </h2>
          <div><DisabledTag codeItem={codeItem} translation={translation} /></div>
        </div>
        {!!longDescription
          ? <div className={`${styles.longDescriptionContainer} ${!!longDescription ? '' : styles.hiddenLongDescriptionContainer}`}>
            <div id="codetable-sticky-header-long-description" className={styles.longDescription} ref={this.longDescriptionRef}>
              {longDescription}
            </div>
          </div>
          : null
        }
      </StickyHeader>
    );
  }
}
